import FlowType from "./flow-type";
import Service from "./service";
import { DateTime } from "luxon";

// Type for YAML-based flows
export interface YamlFlow {
  id: string;
  yamlId?: string;
  slug?: string;
  title?: string;
  name?: string;
  videos?: any[];
  posters?: any[];
  type?: any;
  data?: any;
  service?: any[];
  sys?: {
    createdAt?: string;
  };
  createdAt?: string;
}

export default class Flow {
  id: string;
  name: string;
  slug: string;
  type: FlowType;
  videos: any[];
  posters: any[];
  data: any;
  service?: Service;
  createdAt: DateTime;

  constructor(flow: YamlFlow) {
    this.id = flow.id;
    this.name = flow.title || flow.name!;
    this.slug = flow.slug!;
    this.type = new FlowType(flow.type!);
    this.videos = (flow.videos as any) || [];
    this.posters = (flow.posters as any) || [];
    this.data = flow.data ? JSON.parse(flow.data) : {};

    if (
      flow.service &&
      Array.isArray(flow.service) &&
      flow.service.length > 0
    ) {
      this.service = new Service(flow.service[0]);
    }
    this.createdAt = flow.sys?.createdAt
      ? DateTime.fromISO(flow.sys.createdAt).setZone("Asia/Tokyo")
      : DateTime.now().setZone("Asia/Tokyo");
  }
}
